import parse from 'html-react-parser';
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../styles/colors';
import { breakpoint } from '../../styles/constants';
import { dataAlign, hoverRed } from '../../styles/mixins';

type TextAlign = 'left' | 'center' | 'right';

type TextType = 'alert' | 'classic' | 'disabled' | 'validation' | 'obsolete';

type TextSize = 'small' | 'normal';

export interface WxTextProps {
  title?: string;
  text?: string;
  size?: TextSize;
  darkMode?: boolean;
  align?: TextAlign;
  type?: TextType;
  hover?: boolean;
  bold?: boolean;
  uppercase?: boolean;
  style?: React.CSSProperties;
}

const WxText = ({
  title = '',
  text = '',
  size = 'normal',
  darkMode = false,
  align = 'left',
  type = 'classic',
  hover = false,
  bold = false,
  uppercase = false,
  style,
}: WxTextProps) => (
  <Container
    $darkMode={darkMode}
    data-align={align}
    data-type={type}
    data-size={size}
    $hover={hover}
    $bold={bold}
    $uppercase={uppercase}
    style={style}
  >
    {title && <h3>{title}</h3>}
    {text && <p>{parse(text)}</p>}
  </Container>
);

const Container = styled.div<{
  $darkMode: boolean;
  $hover: boolean;
  $bold: boolean;
  $uppercase: boolean;
}>`
  ${dataAlign}
  --color: ${(props) => (props.$darkMode ? COLORS.white : COLORS.black)};
  --fontsize: 0.75rem;

  font-family: 'Roboto';
  @media (min-width: ${breakpoint}) {
    --fontsize: 0.875rem;
  }

  &[data-size='small'] {
    --fontsize: 0.625rem;
  }

  &[data-type='alert'] {
    --color: ${COLORS.red};
  }

  &[data-type='validation'] {
    --color: ${COLORS.green};
  }

  &[data-type='disabled'] {
    --color: ${(props) =>
      props.$darkMode ? COLORS.darkgray : COLORS.lightgray};
  }

  &[data-type='obsolete'] {
    text-decoration: line-through;
  }

  width: fit-content;

  h3,
  p {
    color: var(--color);
    margin: 0;
    font-size: var(--fontsize);
  }

  h3 {
    font-weight: 900;
    text-transform: uppercase;
    margin-bottom: 0.3125rem;

    @media (min-width: ${breakpoint}) {
      margin-bottom: 0.625rem;
    }
  }

  p {
    font-weight: ${({ $bold }) => ($bold ? 900 : 300)};
    text-transform: ${({ $uppercase }) => ($uppercase ? 'uppercase' : 'none')};
    ${({ $hover }) => $hover && hoverRed};
  }
`;

export default WxText;
